/**
 * Termos que NUNCA se traduzem.
 *
 * Os catálogos (`src/locales/*.json`) referem-se a estes termos por
 * placeholder (`{{apav}}`, `{{number}}`, …) para que o eTranslation — ou
 * qualquer outro motor — não lhes toque. Aqui é que os placeholders recebem
 * o valor final, igual em todas as línguas. Entram no i18next por
 * `interpolation.defaultVariables` (ver src/i18n.js), por isso resolvem em
 * qualquer `t()` sem ser preciso passá-los à mão.
 *
 * Moradas, horários, telefones e emails da APAV SAFE ficam no código (página
 * «O Apoio da APAV»), não no catálogo: não se traduzem e a MT já os partiu
 * noutros sites.
 */
export const NO_TRANSLATE = {
  // 1. APAV, marca e serviços
  apav: 'APAV',
  apavSafe: 'APAV SAFE',
  apavPt: 'APAV.PT',
  infovitimas: 'InfoVítimas',

  // 2. Números que salvam vidas — a MT já os apagou noutros sites.
  //    Vão com isolamento LTR (U+2066…U+2069, invisíveis): sem isso o
  //    algoritmo bidi mostra "116 006" como "006 116" em árabe e urdu.
  number: '⁦116 006⁩',
  emergency: '⁦112⁩',

  // 3. Instituições e fontes (siglas — a MT translitera-as em ru/uk/ar/zh)
  aima: 'AIMA',
  sef: 'SEF',
  acm: 'ACM',
  fra: 'FRA',
  ine: 'INE',
  leiEstatuto: 'Lei n.º 130/2015',

  // 4. Marcas, sites e redes sociais
  travelSafe: 'Travel Safe - Abroad',
  youtube: 'YouTube',
  bluesky: 'Bluesky',
  aoLado: 'Ao Lado das Vítimas',
};

/**
 * Dos termos acima, estes TÊM de atravessar a tradução intactos: o submissor
 * manda-os resolvidos, o recolhedor volta a pô-los como placeholder e o
 * verificador falha o commit se algum se perder.
 *
 * {{aoLado}} fica de fora: é o nome de um podcast em frase e a MT pode
 * legitimamente deixá-lo igual ou não — o recolhedor repõe-o quando o
 * encontra literal.
 */
// Nomes portugueses das instituições, para irem a seguir ao traduzido:
// «Agency for Integration, Migration and Asylum (Agência para a Integração,
// Migrações e Asilo)». Os parênteses vivem aqui dentro, com isolamento LTR —
// sem isso um nome latino longo dentro de um parágrafo árabe parte-se entre
// linhas e o parêntese fecha a meio do nome. Em português não se usam.
export const NOMES_PT = {
  savLisboaNome: '⁦(Serviços de Apoio à Vítima de Lisboa)⁩',
  sefNome: '⁦(Serviço de Estrangeiros e Fronteiras)⁩',
  acmNome: '⁦(Alto Comissariado para as Migrações)⁩',
  aimaNome: '⁦(Agência para a Integração, Migrações e Asilo)⁩',
  cprNome: '⁦(Conselho Português para os Refugiados)⁩',
  crescerNome: '⁦(Associação de Intervenção Comunitária)⁩',
  jrsNome: '⁦(Serviço Jesuíta aos Refugiados em Portugal)⁩',
  oimNome: '⁦(Organização Internacional para as Migrações)⁩',
};
Object.assign(NO_TRANSLATE, NOMES_PT);

export const INVARIANTES = [
  'apav', 'apavSafe', 'apavPt', 'infovitimas',
  'number', 'emergency',
  'aima', 'sef', 'acm', 'fra', 'ine', 'leiEstatuto',
  'travelSafe', 'youtube', 'bluesky',
];

export default NO_TRANSLATE;
